import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionTag, SectionTitle, GoldButton } from "../shared";
import { LANDING_PAGES } from "../../data/landing";

export function LandingFaq({ page, onCta }) {
  return (
    <section className="py-24 lg:py-32 bg-[#0A0A0A]" data-testid="landing-faq">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTag>Frequently Asked</SectionTag>
        <SectionTitle className="mb-12">Questions Buyers <span className="text-gold-gradient italic">Ask Us.</span></SectionTitle>
        <div className="grid lg:grid-cols-2 gap-x-14 gap-y-2">
          {page.faqs.map(([q, a], i) => (
            <Reveal key={q} delay={0.04 * i}>
              <details className="group border-b border-[#D4AF37]/12 py-5" data-testid={`landing-faq-${i}`}>
                <summary className="cursor-pointer list-none flex items-start justify-between gap-4 text-[#F5F5F0] text-base">
                  <h3 className="font-medium">{q}</h3>
                  <span className="text-[#D4AF37] transition-transform group-open:rotate-45 text-xl leading-none">+</span>
                </summary>
                <p className="mt-3 text-sm text-[#A1A1AA] leading-relaxed">{a}</p>
              </details>
            </Reveal>
          ))}
        </div>

        <div className="mt-20 grid lg:grid-cols-[1fr_auto] gap-10 items-center border border-[#D4AF37]/25 bg-[#D4AF37]/[0.04] rounded-[2px] p-8 lg:p-12" data-testid="landing-cta-band">
          <div>
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-3">Next Step</p>
            <p className="font-serif-lux text-2xl sm:text-3xl text-[#F5F5F0]">{page.cta.title}</p>
          </div>
          <GoldButton onClick={onCta} data-testid="landing-cta-btn">{page.cta.title}</GoldButton>
        </div>

        <div className="mt-14">
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-5">Continue Reading</p>
          <div className="grid sm:grid-cols-2 gap-5" data-testid="landing-related">
            {page.related.map((slug) => {
              const r = LANDING_PAGES[slug];
              return (
                <Link key={slug} to={r.path} data-testid={`landing-related-${slug}`} className="group card-lux p-6 rounded-[2px] hover:border-[#D4AF37]/45 transition-colors">
                  <p className="text-[10px] uppercase tracking-[0.25em] text-[#71717A] mb-2">{r.tag}</p>
                  <p className="font-serif-lux text-xl text-[#F5F5F0] flex items-center justify-between gap-3">
                    {r.h1[0]} <ArrowUpRight size={16} className="text-[#D4AF37] opacity-60 group-hover:opacity-100 transition-opacity" />
                  </p>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
